module.exports = __webpack_public_path__ + "img/22.207b55d5.jpg";